import styled from 'styled-components';
import { LauncherElementData, useLauncherElementsStore } from '../../../../hooks/stores/launcherElementsStore';
import { UIData, useUIStore } from '../../../../hooks/stores/uiStore';
import { TextInput } from '../../baseInputs/TextInput';
import { useScene } from '../../../../context/sceneContext';

export const InnerTextVariableInput = () => {
  const scene = useScene();
  const [UIData] = useUIStore<UIData>({ selector: ['selectedElementIDs'] });
  const [launcherElementsData] = useLauncherElementsStore<Record<string, LauncherElementData>>();

  const element = launcherElementsData[UIData.selectedElementIDs?.[0]];
  const innerTextElement = element?.props?.children?.find((child: LauncherElementData) => child.type === 'text');
  const data = innerTextElement?.props;

  const updateText = (value?: string) =>
    scene.updateElementData(innerTextElement.id, { text: value }, 'props');

  return (
    <Row>
      <TextInput label="Inner Text" value={data?.text} onChange={(newValue) => updateText(newValue)} />
    </Row>
  );
};

const Row = styled.div`
  width: 100%;
  display: flex;
`;
